import { isEmpty, get } from 'lodash';
import { getStore, isUserLoggedIn } from './utils';
import { DEFAULT_REDUX_KEY } from '../lib/dynamicStore/constants';
import { SET_SIGN_IN_REDIRECT_KEY, ERROR_STATUS_CODE } from '../global/constants';
import { shortTermTokenExpired } from '../global/actions';

export const getAccessShortTermTokenStatus = response => {
  try {
    if (response.status === ERROR_STATUS_CODE.ERROR_403) {
      throw response;
    }
  } catch (error) {
    if (error.status === ERROR_STATUS_CODE.ERROR_403 && typeof error.text === 'function') {
      error.text().then(errorMessage => {
        if (window[DEFAULT_REDUX_KEY]) {
          const data = JSON.parse(errorMessage);
          const errorData = {
            ...data,
          };
          window[DEFAULT_REDUX_KEY].dispatch(shortTermTokenExpired(errorData));
        }
      });
    }
    throw error;
  }
};

const getRedirectUrl = (storageUrl, redirectUrl) => {
  const store = getStore();
  let redirect = redirectUrl;
  if (isEmpty(redirect)) {
    redirect = get(store, ['global', 'globalData', 'config', 'signInUrl'], '/#');
  }
  const url = storageUrl || window.location.href;
  window.sessionStorage.setItem(SET_SIGN_IN_REDIRECT_KEY, url);
  return redirect;
};

const checkStatus = (
  response,
  storageUrl,
  redirectUrl,
  skipResponseValidation,
  skipUnAuthenticationError
) => {
  if (response.ok) {
    return skipResponseValidation ? {} : response.json();
  }
  if (response.status === 400 && redirectUrl && !isUserLoggedIn()) {
    const url = storageUrl || window.location.href;
    window.sessionStorage.setItem(SET_SIGN_IN_REDIRECT_KEY, url);
    window.open(redirectUrl, '_self');
  }
  if (response.status === 401 && !skipUnAuthenticationError) {
    const redirect = getRedirectUrl(storageUrl, redirectUrl);
    window.open(redirect, '_self');
  }
  getAccessShortTermTokenStatus(response);
  const error = new Error(response.status);
  error.response = response;
  return Promise.reject(error);
};

export default checkStatus;
